const state = {
  entities: [],
  reviewedEntities: [],
  businesses: [],
  subscribers: [],
  crawlers: []
}

export default state;